import * as React from 'react';
import styled from 'styled-components';
import { ButtonWithClickAnalytic, ButtonWithAnalyticProps } from './ButtonWithClickAnalytic';

const Button = styled.button`
  color: rgba(69, 69, 69, 0.6);
  font-size: 0.7em;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  border: none;
  text-decoration: underline;
  cursor: pointer;
  background: none;
  letter-spacing: 0.005em;
  :focus {
    outline: none;
  }
`;

export const AnchorButton: React.FunctionComponent<ButtonWithAnalyticProps> = ButtonWithClickAnalytic(Button);



// WEBPACK FOOTER //
// ./packages/platform-common-ui/components/buttons/AnchorButton.tsx